import { render } from "./BotaoEditar.vue?vue&type=template&id=3e91ac87&ts=true"
import script from "./BotaoEditar.vue?vue&type=script&lang=ts"
export * from "./BotaoEditar.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Botoes/BotaoEditar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e91ac87"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e91ac87', __exports__)) {
    api.reload('3e91ac87', __exports__)
  }
  
  module.hot.accept("./BotaoEditar.vue?vue&type=template&id=3e91ac87&ts=true", () => {
    api.rerender('3e91ac87', render)
  })

}


export default __exports__